import { REVALIDATE_TIME } from "@shared/constants";
import { createSharedConfigService } from "@shared/lib/config";
import { extractError } from "@shared/utils";

export interface CustomDataProvider {
  custom: (params: {
    method: string;
    url: string;
    payload?: any;
    headers?: any;
    options?: any;
  }) => Promise<any>;
}

export const customFetch = async (url: string, options?: RequestInit) => {
  return fetch(url, {
    ...options,
    cache: options?.cache ?? "force-cache",
    next: options?.next ?? (options?.cache === "no-store"
      ? { revalidate: 0 }
      : { revalidate: REVALIDATE_TIME }),
  });
};

export async function refreshNaco() {
  const configService = createSharedConfigService();

  const response = await fetch(`${configService.config.appUrl}/api/naco/refresh`, {
    method: "POST",
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const message = data?.message || (data.error ? extractError(data.error) : null) || response.statusText || "Unknown error";

    return false;
  }

  return data.ok;
}